/*
  Keeps the deals toggle and brand tiles stationary across the full-page
  navigation they perform.

  Absolute scrollY is not enough: the filtered page can differ by a few pixels
  above the grid (active-filter row, item count, font metrics), which reads as
  a small jump. So the click stores where the control itself sat in the
  viewport, and the next page scrolls so the same control returns to that
  exact offset — whatever happened to the content above it. Absolute scrollY
  rides along as the fallback for the rare case the control is missing on the
  next page.

  sessionStorage, not the URL, so shared links never inherit a scroll offset.
  The restore must wait out prerendering: with speculation rules the next page
  runs its scripts on hover, before the click has stored anything, so a
  prerendered document defers the restore to its activation moment.
*/
(() => {
  const KEY = 'lts-filter-scroll';
  const ANCHORS = [
    ['.custom-sale-toggle', '.custom-sale-toggle'],
    ['.custom-deals-brand-chip', '#custom-deals-brand-strip'],
  ];

  document.addEventListener('click', (event) => {
    for (const [controlSelector, anchorSelector] of ANCHORS) {
      const control = event.target.closest(controlSelector);
      if (!control) continue;
      const anchor = document.querySelector(anchorSelector) || control;
      sessionStorage.setItem(KEY, JSON.stringify({
        sel: anchorSelector,
        top: anchor.getBoundingClientRect().top,
        y: Math.round(window.scrollY),
      }));
      return;
    }
  });

  const restore = () => {
    const saved = sessionStorage.getItem(KEY);
    if (saved === null) return;
    sessionStorage.removeItem(KEY);

    let data;
    try {
      data = JSON.parse(saved);
    } catch {
      return;
    }

    let top = data.y;
    const anchor = document.querySelector(data.sel);
    if (anchor) {
      top = anchor.getBoundingClientRect().top + window.scrollY - data.top;
    }
    window.scrollTo({ top: Math.max(Math.round(top), 0), left: 0, behavior: 'instant' });
  };

  if (document.prerendering) {
    document.addEventListener('prerenderingchange', restore, { once: true });
  } else {
    restore();
  }
})();
